/* eslint-disable react/no-unescaped-entities */
import { useEffect, useState } from "react";
import { Car, Inbox, MessageSquare, CheckCircle2 } from "lucide-react";
import api from "@/lib/api";

export default function AdminStats() {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    const load = () => api.get("/stats").then((r) => setStats(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, []);

  const cards = stats
    ? [
        { Icon: Car, label: "Total Vehicles", value: stats.total_cars, accent: false },
        { Icon: CheckCircle2, label: "Available", value: stats.available, accent: false },
        { Icon: Inbox, label: "New Inquiries", value: stats.new_inquiries, accent: stats.new_inquiries > 0 },
        { Icon: MessageSquare, label: "Unread Chats", value: stats.unread_messages, accent: stats.unread_messages > 0 },
      ]
    : [];

  return (
    <div data-testid="admin-stats">
      <h2 className="font-serif text-3xl text-primary">Dashboard</h2>
      <p className="text-sm text-muted-foreground">A bird's-eye view of your dealership.</p>

      <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.length === 0 && [1, 2, 3, 4].map((i) => (
          <div key={i} className="h-28 bg-secondary animate-pulse border border-soft" />
        ))}
        {cards.map((c) => (
          <div
            key={c.label}
            className={`border border-soft bg-card p-6 ${c.accent ? "ring-2 ring-accent/30" : ""}`}
            data-testid={`stat-${c.label.toLowerCase().replace(/\s+/g, "-")}`}
          >
            <div className="flex items-center justify-between">
              <p className="text-xs uppercase tracking-wider text-muted-foreground">{c.label}</p>
              <c.Icon className={`h-4 w-4 ${c.accent ? "text-accent" : "text-muted-foreground"}`} />
            </div>
            <p className="mt-4 font-serif text-4xl text-primary">{c.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
